import {
  parse as fnsParse,
  format,
  isValid,
  isBefore,
  addMonths,
  formatDuration as fnsFormatDuration,
  intervalToDuration,
  Interval,
  parseISO,
} from 'date-fns'
import { datetime } from '~/shared/config'

export { addMonths, format as formatDate, format }

export const fromDateStringApi = (input: string) =>
  fnsParse(input, datetime.apiDateFormat, new Date())

export const fromDataTimeStringApi = (input: string) =>
  fnsParse(input, datetime.apiDateTimeFormat, new Date())

export const fromDatetimeString = (input: string) => parseISO(input)

export const isValidDateString = (input: string) =>
  isValid(fromDateStringApi(input))

export const formatDateForApi = (date: Date) =>
  format(date, datetime.apiDateFormat)

export const formatDateTimeForApi = (date: Date) =>
  format(date, datetime.apiDateTimeFormat)

export const formatDateForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateFormat)

export const formatDateTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateTimeFormat)

export const formatTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiTimeFormat)

export const isBeforeNow = (date: Date | number) => isBefore(date, new Date())

export const formatDuration = (
  duration: Duration,
  options?: {
    format?: string[]
    zero?: boolean
    delimiter?: string
  },
) => fnsFormatDuration(duration, options)

export const formatIntervalAsDuration = (
  interval: Interval,
  options?: { format?: string[]; zero?: boolean; delimiter?: string },
) => {
  const duration = intervalToDuration(interval)
  return fnsFormatDuration(duration, options)
}

export const formatIntervalToNowAsDuration = (
  date: Date,
  options?: { format?: string[]; zero?: boolean; delimiter?: string },
) => {
  const now = new Date()
  return formatIntervalAsDuration({ start: date, end: now }, options)
}
